import { render, staticRenderFns } from "./BankStatementDetails.vue?vue&type=template&id=65163efa&scoped=true&"
import script from "./BankStatementDetails.vue?vue&type=script&lang=js&"
export * from "./BankStatementDetails.vue?vue&type=script&lang=js&"
import style0 from "./BankStatementDetails.vue?vue&type=style&index=0&id=65163efa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65163efa",
  null
  
)

export default component.exports